import React from "react";
import { Link } from "react-router-dom";

export default function ReadOnly() {

    return (
        <div className="readOnlyBanner">
            <p>Lit Pro has been archived and is now read-only. Learn more <Link to="/about" style={{color: 'white'}}>here</Link></p>
        </div>
    )
}
